import { render, staticRenderFns } from "./SelectUsers.vue?vue&type=template&id=4bc435f2"
import script from "./SelectUsers.vue?vue&type=script&lang=js"
export * from "./SelectUsers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports